import React from "react";
import { QRCodeSVG } from "qrcode.react";
import car from "../../Assets/Logos/caricon.jpg";

export default function VehicleRegistrationCertificate2({ data }) {
  // If no data, render nothing
  if (!data) return null;

  return (
    <div className="max-w-md mx-auto p-2 sm:p-4 bg-white rounded-lg shadow border border-gray-200 text-xs sm:text-sm text-gray-800 font-sans tracking-tighter">
      <div className="flex flex-col items-center mb-2 ">
        <div className="relative inline-block">
          <div className="p-4 sm:p-6">
            <QRCodeSVG
              value={
                data.rc_number +
                "" +
                data.vehicle_chasi_number +
                "" +
                data.vehicle_engine_number +
                "" +
                data.maker_description +
                "" +
                data.maker_model +
                "" +
                data.body_type +
                "" +
                data.fuel_type +
                "" +
                data.norms_type +
                "" +
                data.manufacturing_date +
                "" +
                data.seat_capacity +
                "" +
                data.unladen_weight +
                "" +
                data.vehicle_gross_weight +
                "" +
                data.present_address +
                "" +
                data.registration_date +
                "" +
                data.color +
                "" +
                data.gvw +
                "" +
                data.seat_capacity +
                "" +
                data.standing_capacity +
                "" +
                data.financer +
                "" +
                data.insurance_company +
                "" +
                data.insurance_policy_number +
                "" +
                data.insurance_upto +
                "" +
                data.fit_up_to +
                "" +
                data.pucc_number +
                "" +
                data.pucc_upto +
                "" +
                data.rto_code
              }
              level="H"
              size={window.innerWidth < 640 ? 80 : 112}
              includeMargin={false}
            />
          </div>
          {/* Blue corner markers */}
          <div className="absolute top-0 left-0 w-3 sm:w-4 h-3 sm:h-4 border-t-4 border-l-4 border-[#77BEF0]" />
          <div className="absolute top-0 right-0 w-3 sm:w-4 h-3 sm:h-4 border-t-4 border-r-4 border-[#77BEF0]" />
          <div className="absolute bottom-0 left-0 w-3 sm:w-4 h-3 sm:h-4 border-b-4 border-l-4 border-[#77BEF0]" />
          <div className="absolute bottom-0 right-0 w-3 sm:w-4 h-3 sm:h-4 border-b-4 border-r-4 border-[#77BEF0]" />
          {/* Center image icon */}
          <div className="absolute inset-1/2 transform -translate-x-1/2 -translate-y-1/2 w-8 sm:w-10 h-8 sm:h-10 bg-white rounded-full flex items-center justify-center border border-gray-200">
            <img
              src={car}
              alt="Car Icon"
              className="w-8 sm:w-10 h-8 sm:h-10 object-contain border-2 border-gray-900 rounded-full"
            />
          </div>
          <p className="mt-2 font-semibold text-xs sm:text-sm absolute left-[25%] -bottom-2">
            {data.rc_number}
          </p>
        </div>
      </div>
      <br />
      <div className="my-2 sm:my-4 pb-2 sm:pb-4">
        <h1 className="text-gray-700 text-lg sm:text-xl font-bold border-t border-gray-300 pb-1 mb-2">
          Owner Details
        </h1>
        <div className="grid grid-cols-2 gap-y-1 text-xs sm:text-sm">
          <p className="text-gray-500 font-bold">Name</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.owner_name}
          </p>
          <p className="text-gray-500 font-bold">Son/Daughter/Wife of</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.father_name}
          </p>
          <p className="text-gray-500 font-bold">Ownership</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.ownership || "INDIVIDUAL"}
          </p>
        </div>
      </div>

      <div className="border-t border-gray-300 py-2">
        <div className="grid grid-cols-2 gap-y-1 sm:gap-y-2 text-xs sm:text-sm">
          <p className="text-gray-500 font-bold">Chassis No.</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.vehicle_chasi_number}
          </p>
          <p className="text-gray-500 font-bold">Engine No.</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.vehicle_engine_number}
          </p>
          <p className="text-gray-500 font-bold">Maker Name</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.maker_description}
          </p>
          <p className="text-gray-500 font-bold">Model Name</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.maker_model}
          </p>
          <p className="text-gray-500 font-bold">Registration Date</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.registration_date}
          </p>
          <p className="text-gray-500 font-bold">Tax Valid UpTo</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.tax_upto}
          </p>
          <p className="text-gray-500 font-bold">Vehicle Class</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.vehicle_category}
          </p>
          <p className="text-gray-500 font-bold">Description</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.vehicle_category_description}
          </p>
          <p className="text-gray-500 font-bold">Fuel Type</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.fuel_type}
          </p>
          <p className="text-gray-500 font-bold">Emission Norm</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.norms_type}
          </p>
          <p className="text-gray-500 font-bold">Color</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.color}
          </p>
          <p className="text-gray-500 font-bold">GVW</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.vehicle_gross_weight}
          </p>
          <p className="text-gray-500 font-bold">Seat Capacity</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.seat_capacity}
          </p>
          <p className="text-gray-500 font-bold">Standing Capacity</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.standing_capacity}
          </p>
          <p className="text-gray-500 font-bold">Financier</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.financer}
          </p>
          <p className="text-gray-500 font-bold">Insurance Company</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.insurance_company}
          </p>
          <p className="text-gray-500 font-bold">Policy No.</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.insurance_policy_number}
          </p>
          <p className="text-gray-500 font-bold">Insurance Valid Upto</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.insurance_upto}
          </p>
          <p className="text-gray-500 font-bold">Fitness Valid Upto</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.fit_up_to}
          </p>
          <p className="text-gray-500 font-bold">PUCC No.</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.pucc_number}
          </p>
          <p className="text-gray-500 font-bold">PUCC Valid Upto</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.pucc_upto}
          </p>
          <p className="text-gray-500 font-bold">Registering Authority</p>
          <p className="text-[#77BEF0] font-bold text-right break-words">
            {data.registered_at}
          </p>
        </div>
      </div>

      <div className="py-2 sm:py-4 text-xs sm:text-sm font-bold">
        <p className="text-[#77BEF0]">
          Tap to Check the Vehicle impound and Seizure Document Status
        </p>
        <br />
        <p>
          If status of pollution Certificate, Insurance, Tax etc, are not
          available above, same may be verified from physical documents
        </p>
        <br />
        <p>
          Note: This information for the Certificate of Registration is
          generated by mParivahan as per data provided by the issuing authority
          in the National Registry of Ministry of Road Transport and Highways.
          This document is valid as per the IT Act 2000 when used
          electronically.
        </p>
      </div>
    </div>
  );
}
